import i18n from '@/lang/i18n'
import { AgGridColumnType, ExportedColDef, ExportedColGroupDef } from '@/shared/models/ag-grid.model'
import { ColDef } from '@ag-grid-enterprise/all-modules'

export const clinicalPatientGridMasterColumnDefs: (ColDef | ExportedColDef | ExportedColGroupDef)[] = [
    { type: AgGridColumnType.MASTER_DETAIL },
    { type: AgGridColumnType.CUSTOM_CHECKBOX },
    {
        headerName: i18n.tc('global.name'),
        field: 'patName',
        type: AgGridColumnType.TEXT
    },
    {
        headerName: i18n.tc('grid.patMiddleName'),
        field: 'patMiddleName',
        type: AgGridColumnType.TEXT
    },
    {
        headerName: i18n.tc('global.surname1'),
        field: 'patSurname1',
        type: AgGridColumnType.TEXT
    },
    {
        headerName: i18n.tc('global.surname2'),
        field: 'patSurname2',
        type: AgGridColumnType.TEXT
    },
    {
        headerName: 'NHC',
        field: 'centerIdentifier',
        type: AgGridColumnType.TEXT
    },
    {
        headerName: i18n.tc('global.gender'),
        field: 'genderName',
        type: AgGridColumnType.TEXT
    },
    {
        headerName: i18n.tc('global.birthday'),
        field: 'patBirthdate',
        type: AgGridColumnType.DATE,
        width: 120,
        suppressSizeToFit: true
    }
]
